import { modifier } from "@styles/mixins"
import { colors } from "@styles/vars"
import React from "react"
import { ColumnInstance, TableHeaderProps } from "react-table"
import styled, { css } from "styled-components"
import Sort from "./Sort"

type HeaderProps<T extends object> = TableHeaderProps & { column: ColumnInstance<T> }

/**
 * Table's <th> tag.
 */
function Header<T extends object>({ column, ...props }: HeaderProps<T>) {
    const style = {
        width: typeof column.width === "number" ? `${column.width}px` : column.width,
        minWidth: column.minWidth + "px",
        maxWidth: column.maxWidth + "px"
    }

    return (
        <HeaderWrapper {...props} style={style}>
            <HeaderContainer
                isSorted={column.isSorted}
                canSort={column.canSort}
                style={style}>
                {column.render("Header")}
                {column.canSort && <Sort column={column} />}
            </HeaderContainer>
        </HeaderWrapper>
    )
}

export default React.memo(Header) as typeof Header

// COMPONENTS
const HeaderWrapper = styled.th`
    box-sizing: content-box;
`

const HeaderContainer = styled.div<HeaderModifiers>`
    width: 100%;
    display: flex;
    align-items: center;
    color: ${colors.black};

    ${modifier("canSort", css`
        cursor: pointer;
    `)}
`

// TYPES
interface HeaderModifiers {
    isSorted?: boolean,
    canSort?: boolean
}